import { ReactNode, useEffect, useRef } from 'react';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

import { MatomoContext } from './MatomoContext';
import { TMatomoWindowType } from './types';

export function MatomoProvider({ children }: { children: ReactNode }) {
  const mtm = useRef<any>(null);
  const globalWindow = useRef<TMatomoWindowType | null>(null);
  const tracker = useRef<any>(null);
  const config = useDashboardConfig();

  useEffect(() => {
    if (config?.settings?.monitoring?.matomo) {
      const W = window as TMatomoWindowType;
      globalWindow.current = W;

      if (mtm.current === null) {
        const _mtm = W._mtm || [];
        _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
        W._mtm = _mtm;
        const d = document,
          g = d.createElement('script'),
          s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = `https://cdn.matomo.cloud/treezor.matomo.cloud/container_${config.settings?.monitoring.matomo}.js`;
        s.parentNode.insertBefore(g, s);
        mtm.current = W._mtm;

        const interval = setInterval(() => {
          const piwik = W.Piwik;
          if (piwik) {
            tracker.current = piwik.getTracker();
            clearInterval(interval);
          }
        }, 300);
      }
    }
  }, [config?.settings?.monitoring]);

  return (
    <MatomoContext.Provider
      value={{
        mtm: mtm.current,
        tracker: tracker.current,
        window: globalWindow.current,
      }}
    >
      {children}
    </MatomoContext.Provider>
  );
}
